<script>
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import { useDonationsPublicStore } from '@/stores/donationPublic.js'
import TwCard from '@/components/generic/tw-card.vue'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import DonationListGroupItemB from '@/components/donations/public/donation-list-group-item-b.vue'
import TwPaginator from '@/components/generic/tw-paginator.vue'
import fetchItemsMixinWithWatcher from '@/mixins/fetchItemsMixinWithWatcher.js'
export default {
  name: 'FundraiserSupporters',
  components: { TwPaginator, DonationListGroupItemB, TwListGroup, TwCard, TwLoadingSpinner },
  mixins:[fetchItemsMixinWithWatcher],
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    fundraiserPage: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      Loading: false
    }
  },
  computed: {
    itemsStoreModule() {
      return useDonationsPublicStore()
    },
    filters() {
      return {
        fundraiser_id: this.fundraiser.id,
        ...(this.fundraiserPage && { fundraiser_page_id: this.fundraiserPage.id }),
      }
    }
  },
  mounted() {
    this.fetchItems()
  },
  methods: {

  }
}
</script>

<template>
  <div>
    <tw-paginator v-if="showPaginator" v-model="page" class="justify-self-end mb-6" :total="items.length" />
    <h2>
      Donations <span v-if="fundraiser.cached && fundraiser.cached.donations_confirmed_count"> ({{ fundraiser.cached.donations_confirmed_count }}) </span>
    </h2>
    <tw-loading-spinner v-if="LoadingFetchingItems" />
    <tw-list-group v-else-if="!LoadingFetchingItems && items.length > 0">
      <donation-list-group-item-b v-for="donation in items" :key="'fundraiser-supporter-key-' + donation.id" :donation="donation" size="sm" class="mt-2" />
    </tw-list-group>
    <tw-card v-else class="text-center  text-gray-600">
      No supporters yet, make a donation to become the first supporter!
    </tw-card>
  </div>
</template>

<style scoped>

</style>
